import { IconDownload } from "@tabler/icons-react";
import { ReactNode } from "react";

export interface UploadAreaProps {
  title: ReactNode;
  label: ReactNode;
  onChange: (files: File[]) => void;
  disabled?: boolean;
  className?: string;
  accept?: string;
}

const baseStyle = `
  flex flex-col justify-center w-[300px] min-h-[132px] p-8 text-center typography-medium-base select-none
  border border-dashed rounded-lg
`;

const enabledStyle = `
  bg-bg-subtle cursor-pointer border-border-base
  hover:bg-bg-components-hover hover:border-border-strong
  active:bg-bg-components-base active:border-border-interactive-base active:outline-focus active:outline-offset-1
`;

const disabledStyle = "bg-bg-disabled border-border-strong cursor-not-allowed";

const UploadArea = ({
  title, label, onChange, disabled = false, className, accept,
}: UploadAreaProps) => (
  <label htmlFor="file-upload" className={`sds ${baseStyle} ${className} ${disabled ? disabledStyle : enabledStyle}`}>
    <input
      id="file-upload"
      type="file"
      hidden
      onChange={(e) => onChange(Array.from(e.target.files || []))}
      disabled={disabled}
      accept={accept}
    />
    <div className="flex space-x-2 pb-2 justify-center items-center">
      <span className={disabled ? "text-icon-disabled" : "text-icon-bg-subtle"}><IconDownload /></span>
      <span className={disabled ? "text-text-disabled" : "text-text-base"}>{title}</span>
    </div>
    <span className={disabled ? "text-text-disabled" : "text-text-subtle"}>{label}</span>
  </label>
);

export default UploadArea;
